var EqAggregatesContainer = /** @class */ (function () {
    function EqAggregatesContainer(context) {
        this.context = context;
        this.levels = {};
    }
    EqAggregatesContainer.prototype.getAggregateData = function (level, groupKey) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var processFunc = function (data) {
                // map values
                var keyStr = _this.groupKeyToStr(groupKey);
                var value = data.get(keyStr);
                if (value) {
                    resolve(value);
                }
                else {
                    reject("Can't find data for " + keyStr);
                }
            };
            var desc = _this.getLevelDesc(level, false);
            if (desc && desc.data) {
                processFunc(desc.data);
            }
            else {
                desc.receivedCallbacks.push(processFunc);
            }
        });
    };
    EqAggregatesContainer.prototype.setAggregateData = function (level, data) {
        var desc = this.getLevelDesc(level, true);
        desc.data = data;
        if (desc.receivedCallbacks) {
            for (var _i = 0, _a = desc.receivedCallbacks; _i < _a.length; _i++) {
                var callback = _a[_i];
                callback(desc.data);
            }
        }
        desc.receivedCallbacks = [];
    };
    EqAggregatesContainer.prototype.updateAggregateData = function (level, groupKey, values) {
        var desc = this.getLevelDesc(level, true);
        var key = this.groupKeyToStr(groupKey);
        desc.data.set(key, values);
    };
    EqAggregatesContainer.prototype.groupKeyToStr = function (groupKey) {
        return JSON.stringify(groupKey);
    };
    EqAggregatesContainer.prototype.getLevelDesc = function (level, createIfNotExists) {
        var desc = this.levels[level];
        if (!desc && createIfNotExists) {
            desc = {
                receivedCallbacks: [],
                data: new Map()
            };
            this.levels[level] = desc;
        }
        return desc;
    };
    EqAggregatesContainer.prototype.clear = function () {
        this.levels = [];
    };
    return EqAggregatesContainer;
}());
export { EqAggregatesContainer };
var DefaultAggregatesCalculator = /** @class */ (function () {
    function DefaultAggregatesCalculator(context) {
        this.context = context;
        this.aggrs = null;
    }
    DefaultAggregatesCalculator.prototype.getAggrContainer = function () {
        return this.aggrs;
    };
    DefaultAggregatesCalculator.prototype.calculate = function (options) {
        console.warn("Grand totals and sub totals aggregation calculation can be used in Enterprise version only");
        options = options || {};
        options.maxLevel = options.maxLevel >= 0
            ? options.maxLevel : 0;
        this.aggrs = new EqAggregatesContainer(this.context);
        var query = this.context.createQuery();
        query.loadFromData(this.context.getQuery().toJSONData());
        var settings = this.context.getQuery().getAggregationSettings();
        var aggrColId = settings.getAggregates().map(function (a) { return a.colId; });
        var columns = query.getColumns()
            .filter(function (col) { return aggrColId.indexOf(col.id) < 0; });
        for (var i = 0; i < columns.length; i++) {
            columns[i].enabled = false;
        }
        if (settings.hasGrandTotals()) {
            this.aggrs.setAggregateData(0, new Map());
            if (options.resultObtained)
                options.resultObtained({}, 0);
        }
        var groups = settings.getGroups();
        for (var level = 1; level <= groups.length && level <= options.maxLevel; level++) {
            this.aggrs.setAggregateData(level, new Map());
            if (options.resultObtained)
                options.resultObtained({}, level);
        }
        return Promise.resolve();
    };
    DefaultAggregatesCalculator.prototype.needRecalculation = function () {
        return true;
    };
    DefaultAggregatesCalculator.prototype.reset = function () {
    };
    return DefaultAggregatesCalculator;
}());
export { DefaultAggregatesCalculator };
//# sourceMappingURL=eq_aggr_container.js.map